// extracted by mini-css-extract-plugin
module.exports = {"section":"start-project-block_section__rGOP5","block":"start-project-block_block__lbB_U","title":"start-project-block_title__YUoOB","button":"start-project-block_button__mHjBM"};